import { Button } from '@components/button';
import {
  Form,
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from '@components/form/form';
import { Input } from '@components/form/input';
import { DateTimePicker } from '@components/form/dateTimePicker';
import { useCreateBenchUserForm } from '@hooks/staff/benchUsers/createForm';
import { useNavigate, useParams } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

export function CreateBenchUserForm() {
  const { t } = useTranslation('app');
  const { localId } = useParams({ strict: false });
  const navigate = useNavigate();

  const { form, onSubmit, error, isPending } = useCreateBenchUserForm({
    successHandler: () => {
      form.reset();
      toast.success(t('toast.benchUsers.createSuccess'));
      navigate({
        to: '/u/$localId/staff/bench-users',
        params: { localId: localId || '0' },
        replace: true,
      }).catch((err) => {
        console.error(err);
      });
    },
  });

  return (
    <Form {...form}>
      <form
        id="benchUserForm"
        className="flex flex-col gap-4"
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onSubmit={form.handleSubmit(onSubmit)}>
        <FormField
          control={form.control}
          name="username"
          render={({ field }) => (
            <FormItem>
              <FormLabel required>{t('form.username.label')}</FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="password"
          render={({ field }) => (
            <FormItem>
              <FormLabel required>{t('form.password.label')}</FormLabel>
              <FormControl>
                <Input type="password" autoComplete="new-password" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="expiresAt"
          render={({ field }) => (
            <FormItem>
              <FormLabel required>{t('form.expiresAt.label')}</FormLabel>
              <FormControl>
                <DateTimePicker value={field.value} onChange={field.onChange} granularity="day" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        {error && <p className="text-red">{error}</p>}

        <Button type="submit" variant="primary" disabled={isPending} loading={isPending}>
          {t('form.submit.benchUserCreate')}
        </Button>
      </form>
    </Form>
  );
}
